import IApplicationState from 'app/types/state';

function mapSelect(state, n): { value: string; label: string } {
  const sa = state.seasons.seasonsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return {};
}

export function getCurrentSeason(state: IApplicationState) {
  if (
    state.seasons.seasonsById !== undefined
    && state.seasons.currentSeasonId !== undefined
  ) {
    return state.seasons.seasonsById[state.seasons.currentSeasonId];
  }
  return {};
}

export function getCurrentFormSeason(state: IApplicationState) {
  return {
    ...getCurrentSeason(state),
    ...state.seasons.requestedData,
  };
}

export function getSeasonsByIdInSelectFormat(state): any {
  const { seasonsById } = state.seasons;
  const sortedSeasons = _.sortBy(seasonsById, (o) => o.name);
  const mappedTeams = _.map(sortedSeasons, (n) => mapSelect(state, n.id));
  return mappedTeams;
}

export function getSeasons(state: IApplicationState) {
  return {
    ...state.seasons,
    currentSeason: getCurrentSeason(state),
    currentFormSeason: getCurrentFormSeason(state),
    seasonsByIdInSelectFormat: getSeasonsByIdInSelectFormat(state),
  };
}

export function getSeasonSummary(season, dragSelected = false, rows = {}): any {
  const seasonSummary = {
    id: season.id,
    name: season.name,
    // mobile: season.mobile,
    // email: season.email,
    // fullName: season.fullName,
    // teams: { name: season.teamName },
    // dragSelected,
    // selected: rows[season?.id]?.selected,
    // financialStatus: {
    //   owingNumber: season.pendingPaymentCollectionsTotalCount,
    //   overdueNumber: season.overduePaymentCollectionsTotalCount,
    // },
    // amount: rows[season?.id]?.amount,
  };
  return seasonSummary;
}
